import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type StoredFilterValue = string | string[] | number | boolean | null;

export interface FilterPreset {
    id: string;
    summary: string;
    values: Record<string, StoredFilterValue>;
    dateRange: [string, string];
    period: number;
    createdAt: string;
}

interface AdvancedFilterPresetsState {
    recentByScope: Record<string, FilterPreset[]>;
    savedByScope: Record<string, FilterPreset[]>;
}

interface ScopedPresetPayload {
    scope: string;
    preset: FilterPreset;
}

interface ScopedPresetIdPayload {
    scope: string;
    presetId: string;
}

const initialState: AdvancedFilterPresetsState = {
    recentByScope: {},
    savedByScope: {}
};

const advancedFilterPresetsSlice = createSlice({
    name: 'advancedFilterPresets',
    initialState,
    reducers: {
        recordAppliedFilter(state, { payload }: PayloadAction<ScopedPresetPayload>) {
            const recent = state.recentByScope[payload.scope] || [];
            const signature = JSON.stringify({ values: payload.preset.values, dateRange: payload.preset.dateRange, period: payload.preset.period });
            const withoutDuplicate = recent.filter(preset => JSON.stringify({ values: preset.values, dateRange: preset.dateRange, period: preset.period }) !== signature);
            state.recentByScope[payload.scope] = [payload.preset, ...withoutDuplicate].slice(0, 10);
        },
        pinFilter(state, { payload }: PayloadAction<ScopedPresetIdPayload>) {
            const preset = state.recentByScope[payload.scope]?.find(item => item.id === payload.presetId);
            if (!preset) return;

            const saved = state.savedByScope[payload.scope] || [];
            if (!saved.some(item => item.id === preset.id)) {
                state.savedByScope[payload.scope] = [preset, ...saved];
            }
        },
        removeRecentFilter(state, { payload }: PayloadAction<ScopedPresetIdPayload>) {
            state.recentByScope[payload.scope] = (state.recentByScope[payload.scope] || []).filter(item => item.id !== payload.presetId);
        },
        removeSavedFilter(state, { payload }: PayloadAction<ScopedPresetIdPayload>) {
            state.savedByScope[payload.scope] = (state.savedByScope[payload.scope] || []).filter(item => item.id !== payload.presetId);
        }
    }
});

export const { recordAppliedFilter, pinFilter, removeRecentFilter, removeSavedFilter } = advancedFilterPresetsSlice.actions;
export default advancedFilterPresetsSlice.reducer;
